// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"pageWrapper_pageWrapper__tfGIc","pageWrapperContent":"pageWrapper_pageWrapperContent__33gTa"};